import moment from "moment";
import {getWorkerRecentClockIn} from "./../../../services/index";

const errorHandler = async(date, mealValue, lastPunch, timestamp, callback) => {
  console.log("date is ***", date);
  console.log("timestamp is", timestamp);
  const ending = moment(date).add(mealValue?.split(" ")[0], "minutes");
  let recentClockIn = "";
  let exit = false;
  await getWorkerRecentClockIn(lastPunch.workerId)
    .then(async (workerDoc) => {
      recentClockIn = workerDoc;
    });
  console.log("ending at", ending, "date ending", mealValue?.split(" ")[0]);
  if (moment(date).isValid() === false) {
    callback(true, true, "");
  } else if(recentClockIn == undefined && (date <= new Date(lastPunch.inLocalTS))){
      exit = true;
      callback(true, true, "Meal start time must be greater than clock in time");
  } else if(exit == false && (date <= new Date(recentClockIn))) {
    exit = true;
    callback(true, true, "Meal start time must be greater than clock in time");
  } else if (date > new Date() || date > timestamp) {
    callback(true, true, "Selected time cannot be greater than clock out time");
  } else if (ending > new Date() || ending > timestamp) {
    callback(true, true, "Meal end time cannot be greater than clock out time");
  } else {
    callback(false, false, "");
  }
};

export default errorHandler;
